import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_membership_points_txn_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  card_no: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_crm_membership_points_txn_hdr_RowClass
  implements bl_crm_membership_points_txn_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  card_no: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
